import React, { useEffect, useState } from 'react'
import ReactModal from 'react-modal'
import axios from 'axios'
import { creaRegional, obtenerUsuarioEducacion } from '../Services/Rest';
import Swal from 'sweetalert2';

function CrearRegional() {
    const [modalIsOpen, setIsOpen] = useState(false);
    const handleOpenModalTest = () => {
        setIsOpen(true);
    };
    const closeModal = () => {
        setIsOpen(false);
    };

    const [list, setList] = useState([]);
    useEffect(() => {
        axios({
            auth: { username: 'webapp', password: '762tsfsy9826kk87ytttsf' },

            method: 'get',
            url: obtenerUsuarioEducacion
        })
            .then((Response) => {
                setList(Response.data);
                console.log(Response.data)
            }).catch((error) => {
                console.log(error)
            })
    }, [setList]);
    const [postNombre, setPostNombre] = useState([]);
    const [postDescripcion, setPostDescripcion] = useState([]);
    const [postCorreo, setPostCorreo] = useState([]);
    const postData = e => {
        e.preventDefault(e)
        axios({
            auth: { username: 'webapp', password: '762tsfsy9826kk87ytttsf' },

            method: 'post',
            url: creaRegional,
            data: {
                nombre: postDescripcion,
                descripcion: postNombre,
                correo: postCorreo
            }
        })
            .then((Response) => {
                console.log(Response.data)
                Swal.fire({  
                    title: 'Guardado con exito!',  
                    text: 'Añadido.',
                    icon: 'success',
                    timer:3500
                  });
                window.location.reload("/")
            }).catch((error) => {
                Swal.fire({  
                    title: 'Error en los campos',  
                    text: 'Intente de nuevo.',
                    icon: 'warning',
                    timer:3500
                  });
            })
    };
    return (
        <div className="test">
            <button variant="contained" className='btn btn-primary' color="primary" onClick={handleOpenModalTest} > Nueva</button>
            <ReactModal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                contentLabel="Crear ">

                <div className="container">
                    <div className="text-center">
                        <div class="container-fluid">
                            <div class="card shadow mb-4">
                                <div class="card-header py-3">
                                    <h6 class="m-0 font-weight-bold text-primary">Crear Regional</h6>
                                </div>
                                <div class="card-body">
                                    <div class="table-responsive"></div>
                                    <form className="user">
                                        <div className="form-group row">
                                        <div className="col-sm-12">
                                            <select className='btn btn-secondary btn-user btn-block' onChange={(e) => setPostNombre(e.target.value)}>
                                                <option value=''>Seleccione Nombre Gestor</option>
                                                {list.map((item) => (
                                                    <option value={item.nombre}>{item.nombre}</option>
                                                ))
                                                }
                                            </select>
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-sm-12">
                                            <input type="text" className="form-control form-control-user" placeholder="Nombre Regional" onChange={(e) => setPostDescripcion(e.target.value)} />
                                            </div>
                                        </div>
                                        <div className="form-group row">
                                            <div className="col-sm-12">
                                            <select className='btn btn-secondary btn-user btn-block' onChange={(e) => setPostCorreo(e.target.value)}>
                                                <option value=''>Seleccione Correo Gestor</option>
                                                {list.map((item) => (
                                                    <option value={item.correo}>{item.correo}</option>
                                                ))
                                                }
                                            </select>                         
                                                               </div>
                                        </div>
                                        <a ><button className="btn btn-primary btn-user btn-block" type='submit' onClick={postData}>Guardar</button></a>
                                        <hr className="sidebar-divider" />
                                      <a></a>
                                        <hr />
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ReactModal>

        </div>
    )
}
export default CrearRegional;
